import { FiAlertCircle } from "react-icons/fi";

export default function CrudInput({
  label,
  name,
  value,
  onChange,
  error = "",
  required = false,
  type = "text",
  placeholder = "",
  disabled = false,
  readOnly = false,
}) {
  return (
    <div>
      {label && (
        <label className="mb-2 block font-semibold text-white-700">
          {label}

          {required && (
            <span className="ml-1 text-red-500">*</span>
          )}
        </label>
      )}

      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        className={`w-full rounded-xl border p-3 outline-none transition
        ${
          error
            ? "border-red-500"
            : "border-gray-300 focus:border-brand-500"
        }
        ${
          disabled
            ? "cursor-not-allowed bg-gray-100"
            : "bg-white"
        }`}
      />

      {error && (
        <p className="mt-1 flex items-center gap-1 text-sm text-red-500">
          <FiAlertCircle size={14} />
          {error}
        </p>
      )}
    </div>
  );
}